export const LIST = 'LIST';
export const LIST_SUCCESS = 'LIST_SUCCESS';
export const LIST_ERROR = 'LIST_ERROR';
export const CHANGE_VIEW = 'CHANGE_VIEW';
export const EDIT_LEVEL = 'EDIT_LEVEL';
export const EDIT_LEVEL_SUCCESS = 'EDIT_LEVEL_SUCCESS';
export const ADD_LEVEL_SUCCESS = 'ADD_LEVEL_SUCCESS';
export const DELETE_LEVEL = 'DELETE_LEVEL';
